import {DatabaseCode, toDatabaseCode} from "./database-code";
import {transportCategory, TransportCategory} from "./transport-category";

export interface TransportGaugeType extends DatabaseCode {
  categoryRestriction?: TransportCategory
}

const containerDefault: TransportGaugeType = {
  code: 'CONTAINER_DEFAULT',
  categoryRestriction: transportCategory.water,
  displayValue: {
    id: 'common.entity.transportgauge.type.containerdefault',
    defaultMessage: 'Default',
  },
};

const oil: TransportGaugeType = {
  code: 'OIL',
  displayValue: {
    id: 'common.entity.transportgauge.type.oil',
    defaultMessage: 'Oil',
  },
};

const bsw: TransportGaugeType = {
  code: 'BSW',
  categoryRestriction: transportCategory.oil,
  displayValue: {
    id: 'common.entity.transportgauge.type.bsw',
    defaultMessage: 'BS&W Bottoms',
  },
};

export const transportGaugeType = {
  containerDefault,
  oil,
  bsw,
};

export const transportGaugeTypes = Object.values(transportGaugeType);

export const toTransportGaugeType = (code: string): TransportGaugeType => toDatabaseCode(code, transportGaugeTypes);
